export const mutations = {
  // Balance mutations
  setBctBalance(state, bctBalance) {
    state.bctBalance = bctBalance;
  },
  setUSDCBalance(state, data) {
    state.usdcBalance = data;
  },
  setRemainingAllocation(state, data) {
    state.remainingAllocation = data ?? 0;
  },
  setBalances(state, data) {
    state.balances = data;
  },
  setGasPrice(state, data) {
    state.gasPrice = data;
  },

  // Authentication and sign mutations
  setSignInfo(state, newInfo = {}) {
    if (!newInfo || typeof newInfo !== "object") {
      return;
    }
    const { investmentAddress, stage } = newInfo;
    if (
      typeof investmentAddress !== "string" ||
      ["__proto__", "constructor", "prototype"].includes(investmentAddress)
    ) {
      return;
    }
    state.signInfo = {
      ...state.signInfo,
      [investmentAddress]: stage,
    };
  },

  setIsAuthenticated(state, isAuthenticated) {
    state.isAuthenticated = isAuthenticated;
  },

  setAuthSessionExpiresAt(state, expiresAt) {
    state.authSessionExpiresAt = expiresAt;
  },

  // Wallet connection mutations
  setConnectedStatus(state, status) {
    state.isConnected = status;
  },
  setAccounts(state, accounts) {
    state.accounts = accounts;
  },
  setCurrentAccount(state, data) {
    if (
      data &&
      typeof data === "object" &&
      data.address &&
      !data.authAddress &&
      data.type !== "MetaKeep"
    ) {
      state.currentAccount = {
        ...data,
        authAddress: data.address,
      };
      return;
    }
    state.currentAccount = data;
  },
  setCarbonSession(state, data = {}) {
    state.carbonSession = {
      businessWalletAddress: data?.businessWalletAddress || null,
      authWalletAddress: data?.authWalletAddress || null,
    };
  },
  setWalletInfo(state, data) {
    state.walletInfo = data;
  },
  setAdapter(state, data) {
    state.adapter = data;
  },
  setProvider(state, data) {
    state.provider = data;
  },
  setConnectingMetaKeep(state, data) {
    state.connectingMetaKeep = data;
  },

  // Dialog mutations
  setDialogMetamask(state, data) {
    state.dialogMetamask = data;
  },
  setDialogLedger(state, data) {
    state.dialogLedger = data;
  },
  setDialogWeb3Auth(state, data) {
    state.dialogWeb3Auth = data;
  },
  setDialogMetaKeep(state, data) {
    state.dialogMetaKeep = data;
  },

  // Web3Auth mutations
  setWeb3Auth(state, web3auth) {
    state.web3auth = web3auth;
  },
  setWalletServicesPlugin(state, walletServicesPlugin) {
    state.walletServicesPlugin = walletServicesPlugin;
  },

  // Network mutations
  setNetworkId(state, networkId) {
    state.networkId = networkId;
  },
  setNetworkName(state, data) {
    state.networkName = data;
  },
  setRequiredNetworkName(state, data) {
    state.requiredNetworkName = data;
  },
  setNetworkSettings(state, settings) {
    state.networkSettings = settings;
  },

  // Project and offering mutations
  setProjects(state, data) {
    state.projects = data;
  },

  setCreatedOffering(state, data) {
    state.createdOffering = data;
  },
  setCreatedProject(state, data) {
    state.createdProject = data;
  },
  setOfferingState(state, data) {
    state.offeringState = data;
  },

  // Transaction result mutations
  setApprovalResult(state, data) {
    state.approvalResult = data;
  },
  setBidResult(state, data) {
    state.bidResult = data;
  },
  setTxUrl(state, data) {
    state.txUrl = data;
  },
  setWithdrawResult(state, data) {
    state.withdrawResult = data;
  },

  // Commission mutations
  setUsdCommission(state, data) {
    state.usdCommission = data;
  },
  setCarbonCreditCommission(state, data) {
    state.carbonCreditCommission = data;
  },
  setUsdCommissionTransferred(state, data) {
    state.usdCommissionTransferred = data;
  },
  setCarbonCreditCommissionsTransferred(state, data) {
    state.carbonCreditCommissionsTransferred = data;
  },
  setRemainingDeveloperCommission(state, data) {
    state.remainingDeveloperCommission = data;
  },
  setRemainingDeveloperCarbonCreditCommission(state, data) {
    state.remainingDeveloperCarbonCreditCommission = data;
  },
  setCommissionWithdrawn(state, data) {
    state.commissionWithdrawn = data;
  },
  setWithdrawCommission(state, data) {
    state.commissionWithdrawn = data;
  },
  setDeveloperCommissionTransfered(state, data) {
    state.developerCommissionTransfered = data;
  },
  setDeveloperCarbonCreditCommissionsTransferred(state, data) {
    state.developerCarbonCreditCommissionsTransferred = data;
  },

  // Funds and withdrawal mutations
  setFundsPaid(state, data) {
    state.fundsPaid = data;
  },
  setPotentialRefund(state, data) {
    state.potentialRefund = data;
  },
  setIsCancelled: (state, data) => {
    state.isCancelled = data;
  },
  setCouldWithdrawingBackFunds: (state, data) => {
    state.couldWithdrawingBackFunds = data;
  },
  setIsEligibleForWithdrawingBackFunds: (state, data) => {
    state.isEligibleForWithdrawingBackFunds = data;
  },
  insertIntoRemainingFundsUnlocked(state, data) {
    const { key, value } = data;
    state.remainingFundsUnlocked[key] = value;
  },
  setNextUnlockTime(state, data) {
    state.nextUnlockTime = data;
  },
  setListingEnd(state, data) {
    state.listingEnd = data;
  },
  setPaymentSlices(state, data) {
    state.paymentSlices = data;
  },
  setFundsCollected(state, data) {
    state.fundsCollected = data;
  },
  setCurrentPaymentSlice(state, data) {
    state.currentPaymentSlice = data;
  },

  // AML and audit mutations
  setAmlStatusResponse(state, payload) {
    state.amlStatusResponse = payload;
  },
  setAuditWindowOpen(state, data) {
    state.auditWindowOpen = data;
  },
  setUnsuccessfulAudit(state, data) {
    state.unsuccessfulAudit = data;
  },
  setSuccessfulAudit(state, data) {
    state.successfulAudit = data;
  },

  // Error handling mutations
  setWalletErrorMessage(state, data) {
    state.walletErrorMessage = data;
  },
  setServerError(state, data) {
    state.serverError = data;
  },

  // Loading mutations
  setIsLoading(state, data) {
    state.isLoading = data;
  },

  // Admin mutations
  setAdminRole(state, data) {
    state.adminRole = data;
  },

  setUserRecordsCache(state, payload) {
    state.userRecordsCache = payload;
  },

  setIsLogging(state, data) {
    state.isLogging = data;
  }
};
